import { ButtonComponent } from "../../../../ui/molecules/button/newButton";
import { Calendar } from "../../../../ui/molecules/calendar";
import { ProtocolSearch } from "../../../../ui/molecules/ProtocolSearch";
import { MadfarmStaticSelect } from "../../../../ui/molecules/select/newSelect/static";
import { statoRichiestaComplianceRequest } from "../../../../utils";

export function AddStateRequest() {

    return (
        <div className="flex flex-col gap-4 w-full">
            <div className="text-left pb-1 text-md">
                <span className=" font-semibold uppercase tracking-widest text-brandPrimary-600">Stati</span>
                <span className="px-2 font-semibold uppercase tracking-widest text-brandPrimary-300">/</span>
                <span className="font-semibold uppercase tracking-widest text-brandPrimary-800">Creazione</span>
            </div>
            <div className="border-b border-neutral-200 flex flex-col gap-5">
                <MadfarmStaticSelect
                    label='Tipologia della Richiesta'
                    placeholder={'Seleziona Tipologia'}
                    options={statoRichiestaComplianceRequest}
                    onChange={(value) => console.log()}
                    noOptionsMessage={""}
                />
                <Calendar
                    label="Data"
                    onChange={(date) => console.log()}
                />
                <ProtocolSearch
                    type='entry'
                    onSelect={() => { }}
                />
                <ProtocolSearch
                    type='departure'
                    onSelect={() => { }}
                />
                <div className="flex justify-end w-full">
                    <ButtonComponent
                        iconPosition="off"
                        variant="solid"
                        color="orange"
                        label="Aggiungi Stato"
                        size="sm"
                        onClick={() => console.log()}
                    />
                </div>
            </div>
        </div>
    )
}